// Import React
import React from "react";
import PropTypes from "prop-types";
import BenchmarkCollectionsSave from "./BenchmarkCollectionsSave.components";
import Spinner from "../common/Spinner";

BenchmarkCollectionsList.propTypes = {
  user: PropTypes.object,
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
};

export default function BenchmarkCollectionsList(props) {
  const { user } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { benchmarkCollections } = props;

  const display = [];

  benchmarkCollections?.data?.data?.forEach((item) => {
    let listClassName = "benchmark-create-load-or-save-modal-list-item";

    if (item.id === selectedCollection.id) {
      listClassName = "benchmark-create-load-or-save-modal-list-item selected";
    }

    display.push(
      <button
        key={item.id}
        className={listClassName}
        onClick={() => {
          setSelectedCollection(item);
        }}
      >
        {item.project_name}
      </button>
    );
  });

  if (benchmarkCollections.loading) {
    return (
      <div className="benchmark-create-load-or-save-modal-left-pane loading">
        <Spinner></Spinner>
      </div>
    );
  }

  return (
    <div className="benchmark-create-load-or-save-modal-left-pane">
      <div className="benchmark-create-load-or-save-modal-left-pane-list">
        <div className="benchmark-create-load-or-save-modal-left-pane-list-section previously-saved">
          <div className="list-section-items">{display}</div>
        </div>
      </div>
      <div className="benchmark-create-load-or-save-modal-footer left-pane">
        <BenchmarkCollectionsSave
          isCreate={true}
          user={user}
          benchmarkCollections={benchmarkCollections}
        />
      </div>
    </div>
  );
}
